import React from 'react'

const Button = ({content}) => {
    
    const items = content.items.map((item) =>
      <a key={item} href={item.link} target="_blank"><button key={item} className={item.class}>{item.text}</button></a>
    );

  return (
    <div>{items}</div>
  )
}

export default Button